import { ApplicationPhaseSchema, MoneySchema, TimestampSchema } from '@paguz/contracts';
import { z } from 'zod';

/**
 * `GET /v1/admin/metrics?from&to` (`06-backoffice.md` §4.1). `payments` y `reconciliation` son los
 * campos que la API real ya devuelve (módulo `backoffice`); el resto son extensiones opcionales
 * que hoy solo entrega MSW (pendientes de WS-PAY/WS-ORI/WS-AG) y la consola muestra si llegan.
 */
export const AdminMetricsSchema = z.object({
  from: TimestampSchema,
  payments: z.object({
    total: z.int().min(0),
    byStatus: z.record(z.string(), z.number()),
    completedVolume: MoneySchema,
    /** Ratio 0–1 (`COMPLETED / (COMPLETED + FAILED)`) o `null` sin compras terminadas. */
    successRate: z.number().nullable(),
    pendingConfirmation: z.int().min(0),
  }),
  reconciliation: z.object({ openExceptions: z.int().min(0), critical: z.int().min(0) }),
  failuresByReason: z.array(z.object({ reasonCode: z.string(), count: z.int() })).optional(),
  daily: z
    .array(z.object({ date: z.string(), purchases: z.int(), volume: MoneySchema }))
    .optional(),
  origination: z
    .object({
      funnel: z.array(
        z.object({ phase: ApplicationPhaseSchema, count: z.int(), avgHours: z.number() }),
      ),
      started: z.int(),
      active: z.int(),
      approved: z.int(),
      rejected: z.int(),
      counterOffers: z.int(),
      avgHoursToDecision: z.number().nullable(),
    })
    .optional(),
  portfolio: z
    .object({
      approvedLimit: MoneySchema,
      usedLimit: MoneySchema,
      /** Ratio 0–1 como string decimal. */
      usageRate: z.string(),
      delinquentBalance: z.array(z.object({ bucket: z.string(), amount: MoneySchema })),
    })
    .optional(),
});
export type AdminMetrics = z.infer<typeof AdminMetricsSchema>;

/** `GET /v1/admin/integrations` (salud por puerto; forma del registro de adaptadores). */
export const IntegrationHealthSchema = z.object({
  data: z.array(
    z.looseObject({
      port: z.string(),
      adapter: z.string(),
      status: z.string(),
      circuit: z.string().optional(),
      latencyMs: z.number().optional(),
      detail: z.string().optional(),
    }),
  ),
});
export type IntegrationHealth = z.infer<typeof IntegrationHealthSchema>['data'][number];
